import { AbstractSplitUrlDeterminer } from "./SplitUrlDeterminer"
import { SplitUrlMatcher } from "./SplitUrlMatcher"
import { SplitUrlRedirectedCookieStorage } from "./SplitUrlRedirectedCookieStorage"
import HackleCore from "../../core/HackleCore"
import WorkspaceConfig from "../../core/internal/workspace/config/WorkspaceConfig"
import WorkspaceConfigFetcher from "../../core/internal/workspace/config/WorkspaceConfigFetcher"
import { ExperimentConfig, HackleUser } from "../../core/internal/model/model"

export class LocalSplitUrlDeterminer extends AbstractSplitUrlDeterminer<WorkspaceConfig, ExperimentConfig> {
  constructor(
    private readonly workspaceFetcher: WorkspaceConfigFetcher,
    splitUrlMatcher: SplitUrlMatcher,
    splitUrlRedirectedCookieStorage: SplitUrlRedirectedCookieStorage,
    core: HackleCore
  ) {
    super(splitUrlMatcher, splitUrlRedirectedCookieStorage, core)
  }

  protected workspace(user: HackleUser): WorkspaceConfig | null {
    return this.workspaceFetcher.workspace(user)
  }

  protected splitUrlExperiments(workspace: WorkspaceConfig): ExperimentConfig[] {
    return workspace.getSplitUrlExperiments()
  }
}
